import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import type { EUserRole } from '@/types';

interface RequireRoleProps {
  roles: EUserRole[];
  children: React.ReactNode;
}

/**
 * Route guard that checks if the authenticated user's active role is in the allowed list.
 * Redirects to /admin/dashboard if not authorized.
 */
export function RequireRole({ roles, children }: RequireRoleProps) {
  const activeRole = useAuthStore((s) => s.activeRole);

  if (!activeRole || !roles.includes(activeRole)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}
